import React from 'react';
import styled from 'styled-components';
import { Img, ImgProps } from 'react-image';

export const ImageStyle = styled('div')`
  
`;

export const Image = styled((props: ImgProps) => <Img  {...props} />)`
  max-width: 150px;
  @media (max-width: 1024px) {
    max-width: 70px;
  }
`;